import React from "react";
import Container from "./Container";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-primary text-white">
      <Container>
        <div className="grid gap-y-8 md:flex md:gap-6">
          <div className="md:flex-1">
            <h3 className="my-4 md:mt-0 md:mb-6 text-base font-bold leading-loose md:leading-extra-loose">
            <span className="block">
              جمعية التنمية الأهلية بجزيرة دارين
              </span>
              <span className="block">
              مرخصة من قبل المركز الوطني لتنمية القطاع
              </span>
              <span>
              غير الربحي تحت الترخيص رقم 4278
              </span>
            </h3>
            <a href="https://www.vision2030.gov.sa/" target="_blank" rel="noopener noreferrer">
              <img src="/images/footer_logo.png" className="w-44 mt-4" alt="" />
            </a>
          </div>
          <div className="md:flex-1">
            <h3 className="my-4 md:mt-0 md:mb-6 text-lg font-bold">روابط مهمة</h3>
            <ul className="grid gap-y-4 md:gap-y-5 text-base mt-4">
              <li>
                <a href="https://www.iam.gov.sa/" target="_blank" rel="noopener noreferrer" className={'hover:opacity-50 transition-all'}>النفاذ الموحد</a>
              </li>
              <li>
                <a href="https://www.my.gov.sa/wps/portal/snp/main/!ut/p/z1/04_Sj9CPykssy0xPLMnMz0vMAfIjo8zivQIsTAwdDQz9_d29TAwCnQ1DjUy9wgwM3M30w_Wj9KNQlBibOgGV-Jr7OwaHGRoYmEIVGOAAjgb6BdnZgQDi4Jpl/dz/d5/L0lDUmlTUSEhL3dHa0FKRnNBLzROV3FpQSEhL2Fy/" target="_blank" rel="noopener noreferrer" className={'hover:opacity-50 transition-all'}>البوابة الوطنية</a>
              </li>
              <li>
                <a href="https://www.vision2030.gov.sa/" target="_blank" rel="noopener noreferrer" className={'hover:opacity-50 transition-all'}>2030 رؤية</a>
              </li>
              <li>
                <a href="https://es.ncnp.gov.sa/nonprofits" target="_blank" rel="noopener noreferrer" className={'hover:opacity-50 transition-all'}>دليل الجهات غير الربحية</a>
              </li>
              <li>
                <a href="https://portal.etimad.sa/" target="_blank" rel="noopener noreferrer" className={'hover:opacity-50 transition-all'}>منصة الخدمات المالية (اعتماد)</a>
              </li>
              <li>
                <a href="https://nazaha.gov.sa/Services" target="_blank" rel="noopener noreferrer" className={'hover:opacity-50 transition-all'}>الإبلاغ عن حالة فساد</a>
              </li>
            </ul>
          </div>
          <div className="md:flex-1"> 
            <h3 className="mt-4 md:mb-6 md:mt-0 text-lg font-bold">إتصل بنا</h3>
            <ul className="grid gap-y-4 md:gap-y-2 text-base mt-4">
              <li>
                <a href="tel:++966538966772" className={'hover:opacity-50 transition-all'}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="size-10 rounded-full px-2 inline-block ml-2"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span dir="ltr">+966 50 014 1430</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@dareena.org" className={'hover:opacity-50 transition-all'}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="size-10 rounded-full px-2 inline-block ml-2"
                  >
                    <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />
                    <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />
                  </svg>

                  <span>info@dareena.org</span>
                </a>
              </li>
              <li>
                <NavLink to='/' className={'hover:opacity-50 transition-all'}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="size-10 rounded-full px-2 inline-block ml-2"
                  >
                    <path
                      fillRule="evenodd"
                      d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                      clipRule="evenodd"
                    />
                  </svg>

                  <address className="inline not-italic">محافظة القطيف – مركز دارين – جزيرة دارين</address>
                </NavLink>
              </li>
            </ul>
            <h3 className="mt-4 md:mt-6 md:mb-2">تجدنا على</h3>
            <ul className="flex gap-2 items-center mt-2">
              <li>
                <a href="https://www.youtube.com/" target="_blank" className={'hover:opacity-50 transition-all'}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#fff" d="m10 15l5.19-3L10 9zm11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73"/></svg> 
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/" target="_blank" className={'hover:opacity-50 transition-all'}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><path fill="#fff" d="M13.028 2c1.125.003 1.696.009 2.189.023l.194.007c.224.008.445.018.712.03c1.064.05 1.79.218 2.427.465c.66.254 1.216.598 1.772 1.153a4.9 4.9 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428c.012.266.022.487.03.712l.006.194c.015.492.021 1.063.023 2.188l.001.746v1.31a79 79 0 0 1-.023 2.188l-.006.194c-.008.225-.018.446-.03.712c-.05 1.065-.22 1.79-.466 2.428a4.9 4.9 0 0 1-1.153 1.772a4.9 4.9 0 0 1-1.772 1.153c-.637.247-1.363.415-2.427.465l-.712.03l-.194.006c-.493.014-1.064.021-2.189.023l-.746.001h-1.309a78 78 0 0 1-2.189-.023l-.194-.006a63 63 0 0 1-.712-.031c-1.064-.05-1.79-.218-2.428-.465a4.9 4.9 0 0 1-1.771-1.153a4.9 4.9 0 0 1-1.154-1.772c-.247-.637-.415-1.363-.465-2.428l-.03-.712l-.005-.194A79 79 0 0 1 2 13.028v-2.056a79 79 0 0 1 .022-2.188l.007-.194c.008-.225.018-.446.03-.712c.05-1.065.218-1.79.465-2.428A4.9 4.9 0 0 1 3.68 3.678a4.9 4.9 0 0 1 1.77-1.153c.638-.247 1.363-.415 2.428-.465c.266-.012.488-.022.712-.03l.194-.006a79 79 0 0 1 2.188-.023zM12 7a5 5 0 1 0 0 10a5 5 0 0 0 0-10m0 2a3 3 0 1 1 .001 6a3 3 0 0 1 0-6m5.25-3.5a1.25 1.25 0 0 0 0 2.5a1.25 1.25 0 0 0 0-2.5"/></svg>
                </a>
              </li>
              <li>
                <a href="https://x.com/?lang=en" target="_blank" className={'hover:opacity-50 transition-all'}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16"><path fill="#fff" d="M9.294 6.928L14.357 1h-1.2L8.762 6.147L5.25 1H1.2l5.31 7.784L1.2 15h1.2l4.642-5.436L10.751 15h4.05zM7.651 8.852l-.538-.775L2.832 1.91h1.843l3.454 4.977l.538.775l4.491 6.47h-1.843z"/></svg>    
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/" target="_blank" className={'hover:opacity-50 transition-all'}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24"><path fill="#fff" d="M12 2.04c-5.5 0-10 4.49-10 10.02c0 5 3.66 9.15 8.44 9.9v-7H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89c1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9c0-5.53-4.5-10.02-10-10.02"/></svg>                
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
